import React, { Component } from 'react';

export class ProfileView extends Component {

  componentDidMount() {
    if (this.props.moon) {
      this.props.moon.enableInteraction();
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.moon) {
      nextProps.moon.enableInteraction();
      nextProps.moon.selectPlot(nextProps.id);
    }
  }

  render() {
    return (<div></div>);
  }
}



// WEBPACK FOOTER //
// ./src/components/ProfileView.jsx